module.exports = __webpack_public_path__ + "static/media/estateBb.0a4ca849.png";